console.log("🟢 GCA MARKET ENGINE FILE LOADED");

(function attachMarketAdapter(tries = 0) {
  if (window.GCAValueEngine?.estimateCard) {
    console.log("🟢 GCA MARKET ADAPTER ATTACHED");

    const WORKER = "https://gca-ebay-oauth.gareth-faz.workers.dev";
    const baseEstimate = window.GCAValueEngine.estimateCard;

    window.GCAValueEngine.estimateWithMarket = async function (card, queryKey) {
      const ai = baseEstimate(card);

      try {
        const res = await fetch(
          `${WORKER}/market/estimate?queryKey=${encodeURIComponent(queryKey)}`
        );
        const data = await res.json();

        if (data?.status === "ok") {
          ai.market = data.market;
          ai.liquidity = data.liquidity;
          ai.marketBacked = true;
        } else {
          ai.marketBacked = false;
        }
      } catch (err) {
        console.warn("⚠️ Market fetch failed:", err);
        ai.marketBacked = false;
      }

      return ai;
    };

    // ✅ Attach resolveCardValue ONLY once engine exists
    window.GCAValueEngine.resolveCardValue = async function (card, queryKey) {
      let baseAI;
      try {
        baseAI = window.GCAValueEngine.estimateCard(card);
      } catch (e) {
        console.error("❌ Base AI failed", e);
        baseAI = {};
      }

      const safeAI = {
        roiLow: Number(baseAI.roiLow) || 0,
        roiHigh: Number(baseAI.roiHigh) || 0,
        investLabel: baseAI.investLabel || "Hold",
        investText: baseAI.investText || "Insufficient data",
        marketVolatility: baseAI.marketVolatility || { label: "Unknown" },
        trendProjections: baseAI.trendProjections || null
      };

      try {
        if (typeof window.GCAValueEngine.estimateWithMarket === "function") {
          const aiWithMarket = await window.GCAValueEngine.estimateWithMarket(card, queryKey);

          if (
            aiWithMarket &&
            aiWithMarket.marketBacked === true &&
            aiWithMarket.market &&
            Array.isArray(aiWithMarket.market.comps) &&
            aiWithMarket.market.comps.length >= 3
          ) {
            return {
              source: "market",
              ai: {
                roiLow: Number(aiWithMarket.roiLow) || safeAI.roiLow,
                roiHigh: Number(aiWithMarket.roiHigh) || safeAI.roiHigh,
                investLabel: aiWithMarket.investLabel || safeAI.investLabel,
                investText: aiWithMarket.investText || safeAI.investText,
                marketVolatility: aiWithMarket.marketVolatility || safeAI.marketVolatility,
                trendProjections: aiWithMarket.trendProjections || safeAI.trendProjections
              },
              market: { available: true, sampleSize: aiWithMarket.market.comps.length, data: aiWithMarket.market }
            };
          }
        }
      } catch (e) {
        console.warn("⚠️ Market path failed, falling back", e);
      }

      return { source: "fallback", ai: safeAI, market: { available: false, sampleSize: 0, data: null } };
    };

  } else if (tries < 60) {
    setTimeout(() => attachMarketAdapter(tries + 1), 50);
  } else {
    console.error("❌ GCA base engine never became available");
  }
})();
